module.exports = "/_next/static/images/caroline-harrison-a5f29cee5f97587d9af7cfbb4b5b5ebf.jpg";